module.exports = __webpack_public_path__ + "img/icon-question-filled.01311895.svg";